/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacilitySettingValue } from './FacilitySettingValue';
import {
    FacilitySettingValueFromJSON,
    FacilitySettingValueFromJSONTyped,
    FacilitySettingValueToJSON,
    FacilitySettingValueToJSONTyped,
} from './FacilitySettingValue';

/**
 * 
 * @export
 * @interface GetOneFacilitySetting200Response
 */
export interface GetOneFacilitySetting200Response {
    /**
     * 
     */
    data?: FacilitySettingValue;
}

/**
 * Check if a given object implements the GetOneFacilitySetting200Response interface.
 */
export function instanceOfGetOneFacilitySetting200Response(value: object): value is GetOneFacilitySetting200Response {
    return true;
}

export function GetOneFacilitySetting200ResponseFromJSON(json: any): GetOneFacilitySetting200Response {
    return GetOneFacilitySetting200ResponseFromJSONTyped(json, false);
}

export function GetOneFacilitySetting200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOneFacilitySetting200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FacilitySettingValueFromJSON(json['data']),
    };
}

export function GetOneFacilitySetting200ResponseToJSON(json: any): GetOneFacilitySetting200Response {
    return GetOneFacilitySetting200ResponseToJSONTyped(json, false);
}

export function GetOneFacilitySetting200ResponseToJSONTyped(value?: GetOneFacilitySetting200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FacilitySettingValueToJSON(value['data']),
    };
}

